import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GET, POST, PUT, DELETE } from '../../services/api';

// Define the async thunk for adding a tenant
export const addTenantFun = createAsyncThunk(
  'data/add/tenant',
  async (data, { rejectWithValue }) => {
    try {

      const formData = new FormData();

      // Append form fields to FormData
      // Object.keys(data).forEach((key) => {
      //   if (key === "logo" && data[key]) {
      //     formData.append(key, data[key]); // Assuming it's a File object
      //   } else {
      //     formData.append(key, data[key]);
      //   }
      // });

      const response = await POST(`/admin/tenant`, data);
      if (response?.status === 200) {
        return response.data.result;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to fetch data');
    }
  }
);

// Define the async thunk for listing tenants
export const listTenantFun = createAsyncThunk(
  'data/list/tenant',
  async (params = {size:50}, { rejectWithValue }) => {
    try {
      const response = await GET('/admin/tenant', {...params});
      if (response?.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to fetch data');
    }
  }
);

// Define the async thunk for listing tenants
export const listUserTenantFun = createAsyncThunk(
  'data/list/user/tenant',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await GET('/admin/tenant/user', {...params});
      if (response?.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to fetch data');
    }
  }
);

export const listPodcastTenantFun = createAsyncThunk(
  'data/list/podcast/tenant',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await GET('/admin/tenant/user/activity', {...params});
      if (response?.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to fetch data');
    }
  }
);

export const fetchAdminCategory = createAsyncThunk(
  'adminCategory/fetch',
  async (tenant_id, { rejectWithValue }) => {
    try {
      const response = await GET(`/admin/podcast-category/tenant?tenant_id=${tenant_id}&page=1&size=500`);
      if (response?.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to fetch admin category');
    }
  }
);

// http://localhost:5600/api/v1/admin/podcast-category/tenant?tenant_id=2


// http://localhost:5600/api/v1/admin/tenant/user/activity?

export const viewTenantFun = createAsyncThunk(
  "tenant/view",
  async (tenantId, { rejectWithValue }) => {
    try {
      const response = await GET(`/admin/tenant/view`, { tenant_id: tenantId });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || "An error occurred");
    }
  }
);

// Define the async thunk for updating a tenant
export const updateTenantFun = createAsyncThunk(
  'data/update/tenant',
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await PUT(`/admin/tenant?tenant_id=${id}`, data);
      if (response?.status === 200) {
        return response.data.result;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to update data');
    }
  }
);

// Define the async thunk for deleting a tenant
export const deleteTenantFun = createAsyncThunk(
  'data/delete/tenant',
  async (id, { rejectWithValue }) => {
    try {
      const response = await DELETE(`/admin/tenant`, { tenant_id: id });
      if (response?.status === 200) {
        return response.data.result;
      } else {
        return rejectWithValue(response?.data || 'Something went wrong');
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to delete data');
    }
  }
);

const TenantSlice = createSlice({
  name: 'tenant',
  initialState: {
    addTenant: [],
    addTenantLoading: false,
    addTenantError: null,
    listTenant: [],
    listTenantCount: "",
    listTenantLoading: false,
    listTenantError: null,
    listUserTenant: [],
    listUserTenantCount: "",
    listUserTenantLoading: false,
    listUserTenantError: null,

    listPodcastTenant: [],
    listPodcastTenantCount: "",
    listPodcastTenantLoading: false,
    listPodcastTenantError: null,

    listCategoryTenant: [],
    listCategoryTenantCount: "",
    listCategoryTenantLoading: false,
    listCategoryTenantError: null,

    updateTenant: [],
    updateTenantLoading: false,
    updateTenantError: null,
    deleteTenant: [],
    deleteTenantLoading: false,
    deleteTenantError: null,
    viewtenantDetails: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

    

      .addCase(addTenantFun.pending, (state) => {
        state.addTenantLoading = true;
        state.addTenantError = null;
      })
      .addCase(addTenantFun.fulfilled, (state, action) => {
        state.addTenantLoading = false;
        state.addTenant = action.payload;
      })
      .addCase(addTenantFun.rejected, (state, action) => {
        state.addTenantLoading = false;
        state.addTenantError = action.payload.message;
      })

      

      .addCase(viewTenantFun.pending, (state) => {
        state.loading = true;
      })
      .addCase(viewTenantFun.fulfilled, (state, action) => {
        state.loading = false;
        state.viewtenantDetails = action.payload.result;
      })
      .addCase(viewTenantFun.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(listTenantFun.pending, (state) => {
        state.listTenantLoading = true;
        state.listTenantError = null;
      })
      .addCase(listTenantFun.fulfilled, (state, action) => {
        state.listTenantLoading = false;
        state.listTenant = action.payload?.result?.rows;
        state.listTenantCount = action.payload?.result?.count;

        
      })
      .addCase(listTenantFun.rejected, (state, action) => {
        state.listTenantLoading = false;
        state.listTenantError = action.error.message;
      })
      
      .addCase(listPodcastTenantFun.pending, (state) => {
        state.listPodcastTenantLoading = true;
        state.listPodcastTenantError = null;
      })
      .addCase(listPodcastTenantFun.fulfilled, (state, action) => {
        state.listPodcastTenantLoading = false;
        state.listPodcastTenant = action.payload?.result?.rows;
        state.listPodcastTenantCount = action.payload?.result?.count;
      })
      .addCase(listPodcastTenantFun.rejected, (state, action) => {
        state.listPodcastTenantLoading = false;
        state.listPodcastTenantError = action.error.message;
      })

      .addCase(fetchAdminCategory.pending, (state) => {
        state.listCategoryTenantLoading = true;
        state.listCategoryTenantError = null;
      })
      .addCase(fetchAdminCategory.fulfilled, (state, action) => {
        state.listCategoryTenantLoading = false;
        state.listCategoryTenant = action.payload?.result?.rows;
        state.listCategoryTenantCount = action.payload?.result?.count;
      })
      .addCase(fetchAdminCategory.rejected, (state, action) => {
        state.listCategoryTenantLoading = false;
        state.listCategoryTenantError = action.error.message;
      })
      

      .addCase(listUserTenantFun.pending, (state) => {
        state.listUserTenantLoading = true;
        state.listUserTenantError = null;
      })
      .addCase(listUserTenantFun.fulfilled, (state, action) => {
        state.listUserTenantLoading = false;
        state.listUserTenant = action.payload?.result?.rows;
        state.listUserTenantCount = action.payload?.result?.count;

        
      })
      .addCase(listUserTenantFun.rejected, (state, action) => {
        state.listUserTenantLoading = false;
        state.listUserTenantError = action.error.message;
      })



      .addCase(updateTenantFun.pending, (state) => {
        state.updateTenantLoading = true;
        state.updateTenantError = null;
      })
      .addCase(updateTenantFun.fulfilled, (state, action) => {
        state.updateTenantLoading = false;
        state.updateTenant = action.payload;
      })
      .addCase(updateTenantFun.rejected, (state, action) => {
        state.updateTenantLoading = false;
        state.updateTenantError = action.error.message;
      })
      .addCase(deleteTenantFun.pending, (state) => {
        state.deleteTenantLoading = true;
        state.deleteTenantError = null;
      })
      .addCase(deleteTenantFun.fulfilled, (state, action) => {
        state.deleteTenantLoading = false;
        state.deleteTenant = action.payload;
      })
      .addCase(deleteTenantFun.rejected, (state, action) => {
        state.deleteTenantLoading = false;
        state.deleteTenantError = action.error.message;
      });
  },
});

export default TenantSlice.reducer;
